import { render, staticRenderFns } from "./StaticList.vue?vue&type=template&id=31cd4559&scoped=true"
import script from "./StaticList.vue?vue&type=script&lang=ts"
export * from "./StaticList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd4559",
  null
  
)

export default component.exports